import { useTranslation } from 'react-i18next'

import { Input } from '@/components/ui/input'
import { Button } from '@/components/ui/button'
import { FieldLabel } from '../FieldLabel'

export interface ViewabilityTargetEditorProps {
  /** Minimum measured viewability of the ad unit, in percent. */
  value?: number
  onChange: (value: number | undefined) => void
}

/** Requires the ad unit to have at least a given historic viewability. */
export function ViewabilityTargetEditor({ value, onChange }: ViewabilityTargetEditorProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-2">
      <FieldLabel className="text-xs font-medium">{t('targeting.minViewability')}</FieldLabel>
      <div className="flex items-center gap-2">
        <Input
          type="number"
          min={0}
          max={100}
          className="w-32"
          value={value ?? ''}
          placeholder="0"
          onChange={(e) => {
            const parsed = parseFloat(e.target.value)
            onChange(e.target.value === '' || isNaN(parsed) ? undefined : parsed)
          }}
        />
        <span className="text-sm text-muted-foreground">%</span>
        {value !== undefined && (
          <Button type="button" variant="ghost" size="sm" onClick={() => onChange(undefined)}>
            {t('common.clear')}
          </Button>
        )}
      </div>
    </div>
  )
}
